export const BASE_URL = ''
// export const BASE_URL = 'http://localhost:3050/proxy'
export const KEYCLOAK_URL = `${BASE_URL}/auth`
export const KEYCLOAK_REALM_URL = `${KEYCLOAK_URL}/realms/{realmId}`
export const KEYCLOAK_REGISTRATION_URL = `${KEYCLOAK_REALM_URL}/protocol/openid-connect/registrations`
export const KEYCLOAK_FORGOT_PASSWORD_URL = `${KEYCLOAK_REALM_URL}/protocol/openid-connect/forgot-credentials`
export const PROFILE_ENDPOINT = `${KEYCLOAK_URL}/realms/{realmId}/dev-portal/profile`
export const PROFILE_PASSWORD_ENDPOINT = `${KEYCLOAK_URL}/realms/{realmId}/dev-portal/profile/password`
